export default __webpack_public_path__ + "static/media/createPhases.04ecd0ef.png";